import React, {useEffect, useState} from 'react'
import {FiSend, FiFacebook, FiTwitter, FiYoutube, FiInstagram} from "react-icons/fi";
import {Link} from 'react-router-dom';
import { useSelector } from 'react-redux';
import {translate} from "../i18n";

const Footer = () => {
  const language_code = useSelector((state) => state.lang)
  return <>
  <footer className="py-4">
    <div className='container-xxl'>
      <div className='row align-items-center g-3'>
        <div className='col-12 col-md-5'>
          <div className='footer-top-data d-flex gap-30 align-items-center text-white'>
          <FiSend className='fs-3 footer_send flex-shrink-0'/>
            <h2 className="mb-0 footer-newsletter-title">{translate('footer', language_code.lang).newsletter.newsletter_label}</h2>
            
          </div>
        </div>
        <div className='col-12 col-md-7 text-white'>
          <div className="input-group">
            <input type="text" 
                  className="form-control py-1" 
                  placeholder={translate('footer', language_code.lang).newsletter.newsletter_email_placeholder}
                  aria-label="Votre adresse mail" 
                  aria-describedby="basic-addon2" />
            <span className="input-group-text p-2" id="basic-addon2">
              {translate('footer', language_code.lang).newsletter.newsletter_button_text}
            </span>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <footer className="py-4">
    <div className='container-xxl'>
      <div className='row gy-4'>
        <div className='col-12 col-md-6 col-lg-4'>
          <h4 className='text-white mb-4'>{translate('footer', language_code.lang).content_areas.area_1}</h4>
          <div>
            <address>
              <Link className='text-white py-2 mb-1' to="/contact">Formulaire de contact</Link>
              {/* <p className="text-white fs-5">{translate('footer', language_code.lang).headquarters.headquarters_label}:
              <p className="text-white fs-6">{translate('footer', language_code.lang).headquarters.headquarters_street},<br/>
                {translate('footer', language_code.lang).headquarters.headquarters_city}<br/>
                {translate('footer', language_code.lang).headquarters.headquarters_pincode} : 131107</p>
              </p>  */}
            </address>
            {/* <a href="tel:+49 1573 026 98 93" className='mt-3 d-block mb-1 text-white'>+49 1573 026 98 93</a>
            <a href="mailto:contact@assiganto-agro.com" className='mt-4 d-block mb-0 text-white'>contact@assiganto-agro.com</a> */}
            {/*<NavLink to="/contact">{translate('agro_bottom_header', language_code.lang).contact}</NavLink>*/}
            
          </div>
          <div className='social_icons d-flex flex-wrap align-items-center gap-30 mt-4'>
            <a href="https://www.facebook.com/profile.php?id=61576938045463" to="https://www.facebook.com/profile.php?id=61576938045463"><FiFacebook className='fs-4  text-white'/></a>
            <a href="https://www.instagram.com/assiga25337/" to="https://www.instagram.com/assiga25337/"><FiInstagram className='fs-4  text-white'/></a>
            <a href="https://x.com/assigantoagro" to="https://x.com/assigantoagro"><FiTwitter className='fs-4  text-white'/></a>
            <a href="https://www.youtube.com/channel/UC6uJELhWIph5IchakAM3t3g" to="https://www.youtube.com/channel/UC6uJELhWIph5IchakAM3t3g"><FiYoutube className='fs-4  text-white'/></a>

          </div>
        </div>
        <div className='col-6 col-md-6 col-lg-3'>
          <h4 className='text-white mb-4'>{translate('footer', language_code.lang).content_areas.area_2}</h4>
          <div className="footer-links d-flex flex-column">
            <Link className='text-white py-2 mb-1' to='/general-informations'>{translate('footer', language_code.lang).content_labels.content_label_1}</Link>
            <Link className='text-white py-2 mb-1' to='/terms-and-conditions'>{translate('footer', language_code.lang).content_labels.content_label_2}</Link>
            <Link className='text-white py-2 mb-1' to='/shipping-policy'>{translate('footer', language_code.lang).content_labels.content_label_3}</Link>
            <Link className='text-white py-2 mb-1' to='/pre-shipping-policy'>{translate('footer', language_code.lang).content_labels.content_label_4}</Link>
            <Link className='text-white py-2 mb-1' to='/delivery-policy'>{translate('footer', language_code.lang).content_labels.content_label_5}</Link>
          </div>
        </div> 
        <div className='col-6 col-md-6 col-lg-3'>
          <h4 className='text-white mb-4'>{translate('footer', language_code.lang).content_areas.area_3}</h4>
          <div className="footer-links d-flex flex-column">
            <Link className='text-white py-2 mb-1' to='/account-policy'>{translate('footer', language_code.lang).content_labels.content_label_6}</Link>
            <Link className='text-white py-2 mb-1' to="/account-security-policy">{translate('footer', language_code.lang).content_labels.content_label_7}</Link>
            <Link className='text-white py-2 mb-1' to="/payment-policy">{translate('footer', language_code.lang).content_labels.content_label_8}</Link>
            <Link className='text-white py-2 mb-1' to="/cancellation-policy">{translate('footer', language_code.lang).content_labels.content_label_9}</Link>
            <Link className='text-white py-2 mb-1' to="/assiganto-cargo">{translate('footer', language_code.lang).content_labels.content_label_10}</Link>
          </div>
        </div>
        <div className='col-6 col-md-6 col-lg-2'>
          <h4 className='text-white mb-4'>{translate('footer', language_code.lang).content_areas.area_4}</h4>
          <div className="footer-links d-flex flex-column">
            <Link className='text-white py-2 mb-1' to="/getting-started">{translate('footer', language_code.lang).content_labels.content_label_11}</Link>
            <Link className='text-white py-2 mb-1'>{translate('footer', language_code.lang).content_labels.content_label_12}</Link>
            <Link className='text-white py-2 mb-1'>{translate('footer', language_code.lang).content_labels.content_label_13}</Link>
            {/*<Link className='text-white py-2 mb-1'>{translate('footer', language_code.lang).content_labels.content_label_14}</Link>*/}
            <Link className='text-white py-2 mb-1'>{translate('footer', language_code.lang).content_labels.content_label_15}</Link>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <footer className="py-4">
    <div className='container-xxl'>
      <div className='row'>
        <div className='col-12'>
          <p className='text-center mb-0 text-white'>
            &copy; {new Date().getFullYear()} Powered by ASSIGANTO
          </p>
        </div>
      </div>
    </div>
  </footer>
  </>
}

export default Footer